import type {PropsWithChildren} from 'react'

export const EmissionSvg = ({stroke = '#e2ddda', fill = '#ba1221', children}: PropsWithChildren & {stroke?: string; fill?: string}) => (
  <svg
    height={'20px'}
    viewBox={'0 0 120 120'}
    xmlns={'http://www.w3.org/2000/svg'}
    className={'inline-block'}
  >
    <circle
      cx={'60'}
      cy={'60'}
      r={'57'}
      stroke={stroke}
      strokeWidth={'5px'}
      fill={fill}
    />
    <text
      x={'60px'}
      y={'65px'}
      textAnchor={'middle'}
      dominantBaseline={'middle'}
      alignmentBaseline={'middle'}
      stroke={'white'}
      fill={'white'}
      strokeWidth={'3px'}
      fontSize={'4em'}
    >
      {children}
    </text>
  </svg>
)